import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { 
  Box,
  Skeleton,
  CircularProgress, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography,
  Avatar,
  Alert,
  Snackbar
} from "@mui/material";
import AppLayout from "../components/AppLayout";
import BoxComponent from "../components/BoxTile";
import { ArrowBack } from "@mui/icons-material";
import "../css/NewAgenSelectorScreen.css"; // Apply the CSS file
import { saveSlugName } from "../redux/slices/CreateAgentSlice";
import {getRandomImagesForLoadMyAgents, getProfileImage, getProfileImageWithStyle} from '../utills/lib'; // Use specific function for LoadMyAgents
import { deleteAiAgent, resetDeleteAgent } from "../redux/slices/DeployAIAgent";
import { loadAIAgents } from "../redux/slices/LoadAIAgentsSlice";
import WarningIcon from '@mui/icons-material/Warning';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';

const AgentListDashboard = () => {
  const { agentList, agentListLoading } = useSelector((state) => state.LoadAIAgentsSlice);
  const { deleteAgentLoading, deleteAgentError, deleteAgentSuccess } = useSelector((state) => state.DeploySlice);
  console.log('agentList===>123',agentList)
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [agentToDelete, setAgentToDelete] = React.useState(null);

  // Load agents when component mounts or when navigating back
  React.useEffect(() => {
    dispatch(loadAIAgents());
  }, [dispatch, location.pathname]);

  // Refresh agents when coming back from NewAgentViewerScreen1
  React.useEffect(() => {
    if (location.state?.refresh) {
      dispatch(loadAIAgents());
      // Clear the refresh state to prevent unnecessary refreshes
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, dispatch, navigate, location.pathname]);

  React.useEffect(() => {
    if (deleteAgentSuccess) {
      setDeleteDialogOpen(false);
      setAgentToDelete(null);
      dispatch(resetDeleteAgent());
      // Refresh the agent list after successful deletion
      dispatch(loadAIAgents());
    }
  }, [deleteAgentSuccess, dispatch]);

  const handleDeleteClick = (agent) => {
    setAgentToDelete(agent);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    if (agentToDelete) {
      dispatch(deleteAiAgent(agentToDelete?.slug));
    }
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setAgentToDelete(null);
    dispatch(resetDeleteAgent());
  };

  const getBackgroundColor = (data) => { // Ensure field is always an object
    const name = data
  
    if (name === 'invoice') {
      return '#E6D5FF'
    }
    if (name === 'moad-so') {
      return '#D5FEE6';
    }
    return  '#E6D5FF'
  }





  // Agent List Component with Skeleton
  const AgentList = ({ activieSystemAiAgentList }) => {
    if (agentListLoading) {
      return (
        <div className="agent-list-container">
          {[...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={200}
              height={120}
              sx={{ borderRadius: "8px", marginBottom: "16px" }}
            />
          ))}
        </div>
      );
    }

    return (
      <div className="agent-list-container">
 {activieSystemAiAgentList.map((box) => (
  <div
    key={box.id}
    style={{
      marginBottom: '24px',
      borderRadius: '12px',
      overflow: 'hidden', // ensures rounded corners apply to buttons too
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e0e0e0',
    }}
  >
    <BoxComponent
      isLoadMyAgent
      backgroundColor={getBackgroundColor(box.ai_agent)}
      image={getProfileImageWithStyle(box.profile_pic).src}
      title={box.name}
      subtitle={box.slug}
    />
    <div
      style={{
        display: 'flex',
        borderTop: '1px solid #ccc',
      }}
    >
      <button
        onClick={() =>{
          dispatch(saveSlugName(box.slug))
          navigate("/NewAgentViewerScreen", { state: { box, statusDefault: "Completed" } });
        }}
        style={{
          flex: 1,
          padding: '10px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderBottomLeftRadius: '12px',
          cursor: 'pointer',
        }}
      >
        Load
      </button>
      <button
       disabled ={box.ai_agent === 'invoice'}
       onClick={() =>{
        dispatch(saveSlugName(box.slug))
        navigate("/invoiceAgents", { state: {  steps: "Fields",slug:box?.ai_agent,slug_id:box?.slug, profile_pic: box?.profile_pic } });
      }}
        style={{
          flex: 1,
          opacity:box.ai_agent === 'invoice' ? 0.5:1,
          padding: '10px',
          backgroundColor: '#2196F3',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Edit
      </button>
      <button
        onClick={() => handleDeleteClick(box)}
        style={{
          flex: 1,
          padding: '10px',
          backgroundColor: '#F44336',
          color: 'white',
          border: 'none',
          borderBottomRightRadius: '12px',
          cursor: 'pointer',
        }}
      >
        Delete
      </button>
    </div>
  </div>
))}

      </div>
    );
  }    
  return (
    <AppLayout>
          <Box className="header-section">
          <ArrowBack
            onClick={() => navigate("/agentSelection")}
            className="back-icon"
          />
          <h2 className="header-title">Back</h2>
        </Box>

      <h2 className="custom-title">Load My Agents</h2>
      <AgentList activieSystemAiAgentList={agentList} />
      {/* Beautified Delete Confirmation Dialog */}
      <Dialog 
        open={deleteDialogOpen} 
        onClose={handleCloseDeleteDialog}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            minWidth: '400px',
            maxWidth: '500px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          }
        }}
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2, 
          pb: 1,
          borderBottom: '1px solid #e0e0e0'
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 48,
            height: 48,
            borderRadius: '50%',
            backgroundColor: '#fff3e0',
            color: '#f57c00'
          }}>
            <WarningIcon sx={{ fontSize: 28 }} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50' }}>
            Delete AI Agent
          </Typography>
        </DialogTitle>
        
        <DialogContent sx={{ pt: 3, pb: 2 }}>
          {agentToDelete && (
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 2, 
              mb: 3,
              p: 2,
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              border: '1px solid #e9ecef'
            }}>
              <Avatar
                src={getProfileImageWithStyle(agentToDelete.profile_pic).src}
                alt={agentToDelete.name}
                sx={{ 
                  width: 56, 
                  height: 56,
                  ...getProfileImageWithStyle(agentToDelete.profile_pic).style
                }}
              />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50', mb: 0.5 }}>
                  {agentToDelete.name}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6c757d', fontFamily: 'monospace' }}>
                  {agentToDelete.slug}
                </Typography>
              </Box>
            </Box>
          )}
          
          <Typography variant="body1" sx={{ color: '#495057', lineHeight: 1.6 }}>
            Are you sure you want to delete <strong>{agentToDelete?.name}</strong>? 
            This action cannot be undone and will permanently remove the agent and all associated data.
          </Typography>
          
          {deleteAgentError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {deleteAgentError}
            </Alert>
          )}
        </DialogContent>
        
        <DialogActions sx={{ 
          px: 3, 
          pb: 3, 
          gap: 2,
          justifyContent: 'flex-end'
        }}>
          <Button 
            onClick={handleCloseDeleteDialog} 
            variant="outlined" 
            disabled={deleteAgentLoading}
            startIcon={<CancelIcon />}
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
              borderColor: '#6c757d',
              color: '#6c757d',
              '&:hover': {
                borderColor: '#495057',
                backgroundColor: '#f8f9fa'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleConfirmDelete} 
            variant="contained" 
            disabled={deleteAgentLoading}
            startIcon={deleteAgentLoading ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
              backgroundColor: '#dc3545',
              '&:hover': {
                backgroundColor: '#c82333'
              },
              '&:disabled': {
                backgroundColor: '#6c757d'
              }
            }}
          >
            {deleteAgentLoading ? 'Deleting...' : 'Delete Agent'}
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Success Snackbar */}
      <Snackbar
        open={deleteAgentSuccess}
        autoHideDuration={4000}
        onClose={() => dispatch(resetDeleteAgent())}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => dispatch(resetDeleteAgent())} 
          severity="success" 
          sx={{ width: '100%' }}
        >
          Agent deleted successfully!
        </Alert>
      </Snackbar>
    </AppLayout>
  );
};

export default AgentListDashboard;
